import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

//Primereact components
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

// Data table
import { defaultRowOptions, defaultPageRowOptions, Skeletonitems, SkeletonbodyTemplate, paginatorLinks, showingEntries, DesignationFilterOptions } from '../../../appconfig/Settings';

import { getAllDetails } from '../../../service/ProductService';
import AppBreadcrumb from '../../../components/CustomeBreadcrumb/AppBreadcrumb';
import { GET_OFFLINE_GENERATED_CERTIFICATE_DETAIL } from '../../../config/ApiConstant';
import { RefresherCourseCertificationListColumns } from '../../../appconfig/DatatableSetting';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import Loader from '../../../components/Loadeer/Loader';
import { Badge } from 'primereact/badge';

export const ViewOfflineCertificationList = () => {
    document.title = 'Offline Certification List | GSPC';

    // Parameters
    const { id }: any = useParams();

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [certificateList, setCertificateList] = useState<any>([]);

    const [appStatusFilter, setAppStatusFilter] = useState<any>({});

    // useEffect
    useEffect(() => {
        getAllCertificateList();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Search by status
    const searchByStatus = (options: any) => {
        return (
            <Dropdown
                filter
                value={appStatusFilter}
                onChange={(e: any) => {
                    setAppStatusFilter(e.value);
                    options.filterCallback(e.value.code, options.index);
                }}
                options={DesignationFilterOptions}
                optionLabel="name"
                placeholder="Search By Status"
                className="order-drp"
            ></Dropdown>
        );
    };

    // Download Certificate Template
    const downloadCertificateTemplate = (rowData: any) => {
        return (
            <>
                {rowData.certificate_link ? (
                    <a href={rowData.certificate_link} target="_blank" rel="noreferrer">
                        <i
                            className="fa-solid fa-file-pdf fa-xl"
                            style={{ color: "red" }}
                        ></i>
                    </a>
                ) : (
                    <Badge value="Not Generated" severity="danger"></Badge>
                )}
            </>
        )
    };

    // Get all booked candidates list
    const getAllCertificateList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(GET_OFFLINE_GENERATED_CERTIFICATE_DETAIL + '?refresher_id=' + atob(id));
            if (response) {
                const DataList: any = response;

                if (!DataList) {
                    setCertificateList([]);
                } else {
                    setCertificateList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setCertificateList([]);
            }
        } catch (error: any) {
            setPageLoad(false);
            setCertificateList([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
            </>
        );
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined p-button-primary mr-2"></Button>
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
        setGlobalFilter(null);
        setAppStatusFilter(null)
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'Offline Certification List'} pageName={'Member Certification List'} pageTitle={'Member Certification List'} goToPage={true} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={certificateList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    rows={defaultRowOptions}
                                    paginator={certificateList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    className="datatable-responsive p-datatable-sm"
                                    emptyMessage="No Certificates Found"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                >
                                    {RefresherCourseCertificationListColumns.map((col, i) => {
                                        if (col.field === 'SrNo') {
                                            return <Column key={col.field} header={col.header} body={(_, { rowIndex }) => rowIndex + 1} style={{ minWidth: '5rem' }} />;;
                                        } else if (col.field === 'name') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter />;
                                        } else if (col.field === 'email') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter />;
                                        } else if (col.field === 'topic') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter />;
                                        } else if (col.field === 'certificate') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={downloadCertificateTemplate} />;
                                        } else if (col.field === 'designation') {
                                            return <Column key={col.field} field={col.field} header={col.header} filter filterElement={searchByStatus} />;
                                        }
                                        else {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {RefresherCourseCertificationListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>
            {!pageLoad && <Loader />}
        </>
    );
};
